import { render, staticRenderFns } from "./campusClub.vue?vue&type=template&id=a72ccf2c&scoped=true"
import script from "./campusClub.vue?vue&type=script&lang=js"
export * from "./campusClub.vue?vue&type=script&lang=js"
import style0 from "./campusClub.vue?vue&type=style&index=0&id=a72ccf2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72ccf2c",
  null
  
)

export default component.exports